module.exports = "<div class=form-control> <div class=dropdown></div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/year-control/year-control.wx.html
// module id = 1954
// module chunks = 50